import { computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import cloneDeep from 'lodash/cloneDeep';

// Ahora SIEMPRE recibe moduleName
export function useHydratedHeaders(moduleName: string) {
  const preferencesStore = usePreferencesStore();

  return computed(() => {
    // Busca los headers y defaults POR MÓDULO
    const all = cloneDeep(preferencesStore.getAllHeadersByModule(moduleName));
    const def = cloneDeep(preferencesStore.getDefaultHeadersByModule(moduleName));
    const values = preferencesStore.preferences?.[moduleName]?.headers?.data ?? [];

    const hydrated = values.length > 0
      ? values.map(v => cloneDeep(all.find(h => h.value === v))).filter(Boolean)
      : def;
    const headersWithDefaultAdditions = values.length > 0
      ? preferencesStore.hydrateHeadersWithNewDefaults(moduleName, hydrated, def)
      : hydrated;

    // Fixed headers are structural controls, not user-selectable columns.
    // Always restore them first even if an older saved preference omitted them.
    const fixedHeaders = all.filter((header: any) => header.fixed);
    const selectableHeaders = headersWithDefaultAdditions.filter(
      (header: any) => !header.fixed && !fixedHeaders.some((fixed: any) => fixed.value === header.value)
    );

    return [
      ...fixedHeaders,
      ...selectableHeaders,
      { value: 'actions', sortable: false, align: 'end' },
    ];
  });
}
